import { DateRange } from '../types';

export const getSelectionMode = (draftDates: DateRange) => (draftDates.startDate ? 'end' : 'start');
